import React from 'react';

import YatTextReveal from '@pkg/components/Sections/Profile/TextReveal';

import { Ticker, TickerWrapper } from './styles';

interface Props {
    title: string;
}
const TickerTitle = ({ title }: Props) => {
    return (
        <TickerWrapper>
            <Ticker
                animate={{
                    x: [50, -550],
                    transition: {
                        x: {
                            repeat: Infinity,
                            repeatType: 'loop',
                            duration: 6,
                            ease: 'linear',
                        },
                    },
                }}
            >
                <YatTextReveal key={title} text={title + ' '} />
            </Ticker>
        </TickerWrapper>
    );
};

export default TickerTitle;
